export default __webpack_public_path__ + "static/media/seven.aa7d99bb.svg";